import { CheckboxGroup as BaseCheckboxGroup } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseCheckboxGroup)
